<template>
  <modal
    :show="showModal"
    modal-content-classes="bg-dark-200"
    :centered="true"
    :show-close="true"
    body-classes="p-0"
    class="transcript-export--modal"
    @close="showModal = false"
  >
    <div
      slot="header"
      class="d-flex align-items-center"
    >
      <h6 class="text-white mb-0 font-weight-bold">
        Export
      </h6>
    </div>
    <div class="h-divider mt-6" />
    <div class="p-5">
      <div class="mb-2 text-lightblue">
        Choose exporting format
      </div>
      <el-tabs
        v-model="tabName"
        type="border-card"
        class="flex-grow-1 pt-3"
      >
        <el-tab-pane
          label="Transcript"
          name="transcript"
        >
          <div
            v-for="(option, i) in options"
            :key="i"
            class="d-flex align-items-center py-3 rounded-label px-3 mb-3 cursor-pointer"
            :class="
              type != option.value ? 'bg-dark border' : 'transcript-export--active'
            "
            @click="type = option.value"
          >
            <base-radio
              v-model="type"
              class="mt-0 mr-0"
              radio-name="exportType"
              inline
              :name="option.value"
            />
            <component
              :is="option.icon"
              color="grey"
            />
            <div class="text-white ml-2 flex-grow-1">
              {{ option.name }}
            </div>
            <small class="text-lightblue">{{ option.extension }}</small>
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-if="transIsActive && hasTranslation"
          label="Translation"
          name="translation"
        >
          <div
            v-for="(option, i) in translationOptions"
            :key="i"
            class="d-flex align-items-center py-3 rounded-label px-3 mb-3 cursor-pointer"
            :class="
              type != option.value ? 'bg-dark border' : 'transcript-export--active'
            "
            @click="type = option.value"
          >
            <base-radio
              v-model="type"
              class="mt-0 mr-0"
              radio-name="exportType"
              inline
              :name="option.value"
            />
            <component
              :is="option.icon"
              color="grey"
            />
            <div class="text-white ml-2 flex-grow-1">
              {{ option.name }}
            </div>
            <small class="text-lightblue">{{ option.extension }}</small>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="d-flex">
        <base-checkbox
          v-model="withAudio"
          inline
          class="text-white ml-3"
          :disabled="withAudioDisabled"
        >
          Export with audio file
        </base-checkbox>
        <base-checkbox
          v-if="false && tabName === 'translation'"
          v-model="withTranscript"
          inline
          class="text-white ml-3"
          :disabled="withTranscriptDisabled"
        >
          Include transcript with translation
        </base-checkbox>
      </div>
    </div>
    <div class="h-divider" />
    <div class="p-3 d-flex">
      <div class="flex-1" />
      <base-button
        simple
        @click="() => showModal=false"
      >
        Cancel
      </base-button>
      <base-button @click="emit">
        Export
      </base-button>
    </div>
  </modal>
</template>

<script>
import {FileTextIcon, MusicIcon} from "vue-feather-icons";
import {ExportType} from "../../../util/exportUtil";
import BaseButton from "../../BaseButton.vue";
import BaseCheckbox from "../../Inputs/BaseCheckbox.vue";
import BaseRadio from "../../Inputs/BaseRadio.vue";
import Modal from "../Modal.vue";
import {mapGetters} from "vuex";

export default {
  components: {
    Modal,
    BaseButton,
    BaseRadio,
    FileTextIcon,
    MusicIcon,
    BaseCheckbox,
  },

  data() {
    return {
      type: ExportType.alt,
      withAudio: false,
      withTranscript: true,
      showModal: false,
      loading: false,
      tabName: "transcript",
      hasTranslation: false,
      options: [
        {
          name: "Unformatted Transcript",
          extension: "MS Word file (.docx)",
          icon: FileTextIcon,
          value: ExportType.nonFormatted,
        },
        {
          name: "Numbered Transcript",
          extension: "MS Word file (.docx)",
          icon: FileTextIcon,
          value: ExportType.alt,
        },
        {
          name: "Only Audio",
          extension: "Audio file (.mp3)",
          icon: MusicIcon,
          value: ExportType.audio,
        },
      ],
      translationOptions: [
        {
          name: "Unformatted Translation",
          extension: "MS Word file (.docx)",
          icon: FileTextIcon,
          value: ExportType.nonFormattedTranslation,
        },
        {
          name: "Numbered Translation",
          extension: "MS Word file (.docx)",
          icon: FileTextIcon,
          value: ExportType.altTranslation,
        },
        {
          name: "Only Audio",
          extension: "Audio file (.mp3)",
          icon: MusicIcon,
          value: ExportType.audio,
        },
      ],
    };
  },
  watch: {
    tabName: {
      handler(n, o) {
        if (n === "transcript") {
          if (this.type === ExportType.standardTranslation) {
            this.type = ExportType.standard;
          } else if (this.type === ExportType.nonFormattedTranslation) {
            this.type = ExportType.nonFormatted;
          } else if (this.type === ExportType.altTranslation) {
            this.type = ExportType.alt;
          }
        } else if (n === "translation") {
          if (this.type === ExportType.standard) {
            this.type = ExportType.standardTranslation;
          } else if (this.type === ExportType.nonFormatted) {
            this.type = ExportType.nonFormattedTranslation;
          } else if (this.type === ExportType.alt) {
            this.type = ExportType.altTranslation;
          }
        }
      },
    },
  },
  computed: {
    ...mapGetters("data", [
      "translationIsActive",
    ]),
    withAudioDisabled() {
      return this.type === ExportType.audio;
    },
    withTranscriptDisabled() {
      return this.type === ExportType.audio;
    },
    transIsActive() {
      return this.translationIsActive;
    },
  },
  methods: {
    emit() {
      this.$emit("export", {type: this.type, withAudio: this.withAudio});
      this.showModal = false;
    },
    display(hasTranslation, initialTab = null) {
      this.hasTranslation = hasTranslation;
      if (initialTab) {
        this.tabName = initialTab;
      } else {
        this.tabName = "transcript";
      }
      this.showModal = true;
    },
  },
};
</script>

<style>
.transcript-export--modal .modal-dialog {
  max-width: 600px !important;
}
.transcript-export--active {
  background: #1f3300;
  border: 1px solid #426511 !important;
}
</style>
